import fecha from "fecha";

export const format = 'YYYY-MM-DD HH:mm:ss';
function Fecha(val, _format=format) {
    if (val && typeof val === 'string') {
        return fecha.parse(val, _format);
    } else if (val && val.constructor === Date) {
        return fecha.format(val, _format);
    } else {
        return val;
    }
}

Fecha.parse = function (val, _format = format) {
    if (val && typeof val === 'string') {
        return fecha.parse(val, _format);
    }else {
        return val;
    }
}

Fecha.format = function (val, _format = format) {
    if (val && val.constructor === Date){
        return fecha.format(val, _format);
    }else{
        return val;
    }
}
export default Fecha;
